import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import HeroSlider from "./HeroSlider";

const content = [
  {
    subheading: "EXPLORE OUR TECH GADGETS",
    heading: "Discover the Latest Tech Gadgets",
    image: "/images/laptop.png",
    paragraph: `     Dive into the world of cutting-edge technology with our range of laptops, monitors, mobiles, and smartwatches.
                  `,
  },
  {
    subheading: "UNLEASH YOUR TECH POTENTIAL",
    heading: "Elevate Your Digital Experience",
    image: "/images/smartwatch.png",
    paragraph: ` Elevate your digital lifestyle with our high-quality tech products. Experience innovation like never before.
                  `,
  },
  {
    subheading: "STAY CONNECTED ON-THE-GO",
    heading: "Mobile Freedom in Your Hands",
    image: "/images/mobile.png",
    paragraph: ` Stay connected wherever you go with our mobile devices. Seamless communication and entertainment await.
                   `,
  },
  {
    subheading: "OPTIMIZE YOUR WORKSPACE",
    heading: "Boost Productivity with Monitors",
    image: "/images/monitor.png",
    paragraph: ` Maximize your productivity with our top-notch monitors. Crisp visuals and enhanced efficiency at your service.
                   `,
  },
];

const HeroBanner = () => {
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    infinite: true,
    fade: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <>
      <div
        className="text-black bg-teal-400 relative h-[70vh] "
        style={{
          backgroundImage: `url(/images/banners.jpg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Slider ref={sliderRef} {...settings}>
          {content.map((data, index) => (
            <HeroSlider
              sliderRef={sliderRef}
              paragraph={data.paragraph}
              key={index}
              subheading={data.subheading}
              heading={data.heading}
              image={data.image}
            />
          ))}
        </Slider>
      </div>
    </>
  );
};

export default HeroBanner;
